import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/styles/hljs';
import personalDataKeys from './../../data/personalDataKeys';
import ApiDefinitionRow from '../ApiDefinitionRow';
import { translate } from 'react-i18next';
import personalDataExampleObject from '../../data/personalDataExampleObject';

const PersonalDataSection = (props) => (

  <section className="method row" id="personal-information">
    <div className="method__text method__text col-lg-6 overflow-scroll-block">
      <h1 className="h2">{props.t('title')}</h1>
      <hr />
      <ul className="api-definition-list">
        { personalDataKeys.map((item, index) => <ApiDefinitionRow item={item} key={index} namespaces={['personalInformation']} /> )}
      </ul>
    </div>
    <div className="method__code col-lg-6">
      <small>{props.t('example.personalDataEndpoint')}</small>
      <SyntaxHighlighter language='text' style={sunburst}>
        {
          `https://mise.se/TestAPI/api/`
        }          
      </SyntaxHighlighter>
      <small>{props.t('example.personObject')}</small>
      <SyntaxHighlighter language='json' style={sunburst}>
        {props.t('personDataExampleObject')}
      </SyntaxHighlighter>
    </div>
  </section>

);

export default translate('personalInformation')(PersonalDataSection);



// WEBPACK FOOTER //
// ./src/components/sections/PersonalDataSection.jsx